module.exports = __webpack_public_path__ + "img/6E524D_8496C5_AF6624_100B11-256px.35ad4de0.png";